export default __webpack_public_path__ + "static/camilo-e9d67e94c5dcf7ef24288a7f1ab14f42.png";